import { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { ArrowDown, Calendar } from 'react-feather'
import { useTranslation } from 'react-i18next'
import './index.scss'

export const SortByDateDropdown = ({
  orderBy = 'newest',
  onOrderByChange,
  className = '',
  iconSize = 18,
  style = {},
}) => {
  const { t } = useTranslation()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const isOldest = orderBy === 'oldest'

  return (
    <div className={`sort-dropdown-container ${className}`} style={style}>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle caret color="outline-secondary">
          <ArrowDown
            size={iconSize}
            className={`sort-arrow ${isOldest ? 'rotate-up' : ''}`}
          />
          <Calendar size={iconSize} style={{ marginRight: 8, marginLeft: 8 }} />
          {t('sort-by-date')}
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem active={isOldest} onClick={() => onOrderByChange('oldest')}>
            <ArrowDown size={iconSize} className="rotate-up me-1" />
            {t('oldest-first')}
          </DropdownItem>
          <DropdownItem active={!isOldest} onClick={() => onOrderByChange('newest')}>
            <ArrowDown size={iconSize} className="me-1" />
            {t('newest-first')}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}
